import React from 'react'
import './404.css'

type Props = {}

const P404: React.FC<Props> = () => (
  <div className="container">
    <h1>404</h1>
    <p>Page is not found</p>
  </div>
)

export default P404
